const componentSerializationKey = 'SelectedLegComponent';
// This is used for old platsa solutions that was created using this component before it was moved to the shared folder
const oldPlatsaComponentSerializationKey = 'PlatsaSelectedLegComponent';
export class SelectedLegComponentSerializer {
    constructor() {
        this.thisClassIsGuaranteedToNotModifyOrQueryCoreState = true;
    }
    canHandle(serializationKey) {
        return (serializationKey === componentSerializationKey ||
            serializationKey === oldPlatsaComponentSerializationKey);
    }
    deserialize(serializationKey, json) {
        switch (serializationKey) {
            case componentSerializationKey:
                return new SelectedLegComponent(JSON.parse(json).coreProductId);
            case oldPlatsaComponentSerializationKey:
                return new SelectedLegComponent(JSON.parse(json).coreProductId);
        }
        return null;
    }
}
class SelectedLegComponent {
    constructor(coreProductId) {
        this.typeId = SelectedLegComponent.id;
        this.doStoreInSnapshot = true;
        this.serializable = true;
        this.coreProductId = coreProductId;
    }
    serializationKey() {
        return componentSerializationKey;
    }
    toJson(parse) {
        return parse(JSON.stringify(this));
    }
    eq() {
        return false;
    }
}
SelectedLegComponent.id = 2046;
export default SelectedLegComponent;
//# sourceMappingURL=SelectedLegComponent.js.map